"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MetadataColumns {
    constructor(obj) {
        this.field_name = obj.field_name || null;
        this.plant_date = obj.plant_date || null;
        this.uuid_client_field = obj.uuid_client_field || null;
        this.variety = obj.variety || null;
        this.density = obj.density || null;
        this.biodynamic_methods = obj.biodynamic_methods || null;
        this.artificial_irrigation = obj.artificial_irrigation || null;
        this.irrigation_type = obj.irrigation_type || null;
        this.irrigation_usage = obj.irrigation_usage || null;
    }
}
exports.default = MetadataColumns;
